import gql from "graphql-tag";

export const MY_HR_REQUEST_PERMIT = gql`
  mutation requestPermit($locale: String!) {
    requestPermit(locale: $locale) {
      _id
    }
  }
`;
